export default "__VITE_ASSET__BaWeBD6l__"